import { selectors as storageSelectors } from "../storage";

/**
 *
 */

const reduxEvents = [];
let libraryMountCount = 0;
export default store => next => action => {
  try {
    if (libraryMountCount >= 0) {
      if (
        action.type === "LIBRARY_TAB_REMOUNTED_ON_MOUNT" ||
        action.type === "LIBRARY_TAB_REMOUNTED_ON_UPDATE"
      ) {
        libraryMountCount++;
        setTimeout(() => libraryMountCount--, 30000);
        if (libraryMountCount > 8) {
          // log to insights
          const state = store.getState();
          const redirect = storageSelectors.getKey(state, "storedRedirect", {
            userScope: false
          });
          Jigsaw.addEvents({
            name: "RemountBug6",
            redirect,
            last100: JSON.stringify(reduxEvents),
            persistRedirect: JSON.stringify(
              (
                JSON.parse(localStorage.getItem("persist") || "{}")[
                  "__storedRedirect"
                ] || {}
              ).value || "NONE"
            )
          });

          libraryMountCount = -1;
        }
      }

      if (action.type === "update/history") {
        reduxEvents.push(action.type + " - " + action.data.location.hash);
      } else {
        reduxEvents.push(action.type);
      }
      if (reduxEvents.length > 50) {
        reduxEvents.shift();
      }
    }
  } catch (e) {}
  next(action);
};
